import React, {useEffect, useState} from 'react';
import {createStore, StateMachineProvider} from 'little-state-machine';
import LoadingPage from 'components/LoadingPage';
import usePostBin from 'hooks/usePostBin';
import {useGetBin} from 'hooks/useGetEndpoint';

// We can't update middleware after init, so drop down out of react for a second
let persistTimeout;
let isServerSet = true;
const FormStateProvider = function ({children}) {
    const {post} = usePostBin();
    const {data: serverState, error: errorState} = useGetBin();
    const [inited, setInited] = useState(false);

    function log(store) {
        console.info('[FormStateProvider] Store updated', store);
    }

    const persist = store => {
        const poster = post;
        if (persistTimeout) {
            clearTimeout(persistTimeout);
        }
        if (!isServerSet) {
            persistTimeout = setTimeout(() => {
                poster({
                    url: window.location.pathname,
                    form_state_json: store,
                });
            }, 1000);
        } else {
            isServerSet = false;
        }
    };

    const middleware = [persist];
    if (process.env.NODE_ENV !== 'production') {
        middleware.push(log);
    }

    useEffect(() => {
        if (errorState && process.env.NODE_ENV === 'development') {
            console.error(
                '[FormStateProvider :: restoreServerState] Failed',
                errorState
            );
        }
        if (
            serverState?.form_state_json &&
            process.env.NODE_ENV === 'development'
        ) {
            console.info(
                '[FormStateProvider :: restoreServerState]',
                serverState
            );
        }
        if (serverState?.form_state_json) {
            localStorage.setItem(
                '__STATE_MACHINE__',
                JSON.stringify(serverState.form_state_json)
            );
        }
        if (serverState || errorState) {
            const state = serverState?.form_state_json || {};
            // Init store
            createStore(state, {
                name: '__STATE_MACHINE__',
                middleWares: middleware,
                storageType: window.localStorage,
            });
            setInited(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorState, serverState]);

    return !inited ? (
        <LoadingPage message='Fetching your progress...' />
    ) : (
        <StateMachineProvider>{children}</StateMachineProvider>
    );
};

/**
 * Wraps a passed react component with a little-state-machine provider
 * Will log out state updates in development
 * @param {React.Component} Component
 */
export function withStateMachine(Component) {
    const StateComponent = function (props) {
        return (
            <FormStateProvider>
                {React.createElement(Component, props)}
            </FormStateProvider>
        );
    };
    StateComponent.displayName = `withStateMachine(${
        Component?.displayName || Component?.name
    })`;

    return StateComponent;
}
export default FormStateProvider;
